import React, { useState } from 'react';
import classes from './style.module.scss';
import useTranslation from '~/app/hooks/useTranslation';
import Icon from '~/app/common/Icon';
import FileIcon from '~/documentation/Archives/List/ListItem/FileIcon';
import { getAttachmentFileName, getExtensionFromName } from '~/messages/attachmentUtils';

export interface AttachmentsProps {
    files?: string[];
}

export type AttachmentsComponent = React.FC<AttachmentsProps>;

const Attachments: AttachmentsComponent = ({ files }) => {
    const { t } = useTranslation('issue');
    const [isExpanded, setIsExpanded] = useState<boolean>(false);

    if (!files || files.length === 0) {
        return null;
    }

    return (
        <div className={classes['container']}>
            <div className={classes['header']} onClick={() => setIsExpanded(prev => !prev)}>
                <span className={classes['headerText']}>
                    {t('attachments.title')} ({files.length})
                </span>
                <Icon name={isExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'} className={classes['chevron']} />
            </div>
            {isExpanded && (
                <div className={classes['list']}>
                    {files.map((fileUrl, index) => {
                        const fileName = getAttachmentFileName(fileUrl);
                        const rawExtension = getExtensionFromName(fileUrl);
                        const extension = rawExtension.replace(/^\./, '');

                        return (
                            <a
                                key={index}
                                href={fileUrl}
                                className={classes['resource-item']}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <div className={classes['resource-info']}>
                                    <div className={classes['resource-title']}>
                                        <FileIcon extension={extension} className={classes['file-icon']} />
                                        <span className={classes['resource-title-text']}>{fileName}</span>
                                    </div>
                                </div>
                                <div className={classes['resource-icon']}>↗</div>
                            </a>
                        );
                    })}
                </div>
            )}
            <hr className={classes['bottomLine']} />
        </div>
    );
};

export default Attachments;
